import { createSlice } from '@reduxjs/toolkit';

interface UserInfoState {
  refreshToken?: string | null;
}

export const authSlice = createSlice({
  name: 'Auth',
  initialState: {
    value: {} as UserInfoState,
  },
  reducers: {
    setUserInfo: (state, action: { payload: string | undefined | null }) => {
      state.value.refreshToken = action.payload;
    },
  },
});

export const { setUserInfo } = authSlice.actions;

export default authSlice.reducer;
